export const environment = {
  production: false,
  apiEndpoint: 'https://maintenance-tracker-api.azurewebsites.net/',
  publicApiEndpoint: 'https://maintenance-tracker-api-public.azurewebsites.net/',
  origin: 'http://localhost:4200/'
};
